import ReducerGenerator from '../../lib/ReducerGenerator'

const generator = new ReducerGenerator('sheet_rates_publishing')
const reducer = generator.generate()

export default reducer
